<template>
  <div v-if="showModal" class="modal-container">
    <div class="fixed inset-0 z-40 bg-black opacity-50"></div>
    
    <div class="modal-content max-w-lg w-full max-h-[90vh] relative bg-white m-auto flex-col flex rounded-lg z-50">
      <div class="w-full border-b-[1px] mb-4 px-6 py-4">
        <h2 class="text-[18px] text-grayDark font-bold">{{ modalTitle }}</h2>        
      </div>

      <form @submit.prevent="submitModal" class="overflow-y-auto px-6" enctype="multipart/form-data">
        <div class="mb-4 space-y-4">
          <div>
            <div>
              <div>
                <label class="block text-[13px] font-medium text-grayDark">Manager</label>
                <select v-if="!loading && isAdmin" v-model="selectedManagerId" placeholder="Select manager" class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" required>
                  <option v-for="manager in managers" :key="manager.manager_id" :value="manager.manager_id">
                    {{ manager.contact_name }} ({{ manager.contact_email }})
                  </option>
                </select>
                <p v-else-if="!loading" class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" required>
                    {{ managerName }} ({{ managerEmail }})
                </p>
              </div>
            </div>
          </div>
          
          <div>
            <label class="block text-[13px] font-medium text-grayDark">Cover Image</label>
            <input 
              type="file" 
              @change="handleFileUpload" 
              accept="image/*" 
              class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
            />
            <div v-if="coverImagePreview" class="mt-2">
              <img :src="coverImagePreview" alt="Cover preview" class="h-32 object-cover rounded-md" />
            </div>
          </div>
          
          <div class="">
            <label class="block text-[13px] font-medium text-grayDark">Goal Name</label>
            <input v-model="newProject.project_name" type="text" placeholder="Example goal" class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" required />
          </div>
          <div class="">
            <label class="block text-[13px] font-medium text-grayDark">Description</label>
            <textarea v-model="newProject.description" placeholder="Enter goal description" class="mt-1 block w-full h-[152px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" required></textarea>
          </div>
          <div class="flex justify-between">
            <div class="">
              <label class="block text-[13px] font-medium text-grayDark">Start Date</label>
              <input v-model="newProject.start_date" type="date" class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9] w-[243px] h-[42]" required />
            </div>
            <div class="">
              <label class="block text-[13px] font-medium text-grayDark">End Date</label>
              <input v-model="newProject.end_date" type="date" class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9] w-[243px] h-[42]" required />
            </div>            
          </div>
          <div class="">
            <label class="block text-[13px] font-medium text-grayDark">Status</label>
            <select v-model="newProject.status" class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" required>
              <option value="Select Status" default>Select status</option>
              <option value="Active">Active</option>
              <option value="Completed">Completed</option>
              <option value="On Hold">On Hold</option>
            </select>
          </div>

          <div class="mb-4">
            <div>
              <label class="block text-[13px] font-medium text-grayDark">Tags</label>
              <div class="mt-2">
                <!-- Dropdown for selecting tags -->
                <select
                  v-model="selectedTag"
                  @change="addTag"
                  class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-[14px] bg-[#F6F8F9]"
                >
                  <option disabled value="" class="">Select a tag</option>
                  <option v-for="tag in availableTags" :key="tag" :value="tag" class="">
                    {{ tag }}
                  </option>
                </select>
              </div>
              <!-- Display Selected Tags -->
              <div class="flex flex-wrap items-center gap-2 mt-4">
                <span
                  v-for="(tag, index) in newProject.tags"
                  :key="index"
                  class="flex items-center px-2 py-2 bg-primaryLight text-grayDark border border-grayLight rounded-[6px] cursor-pointer"
                >
                  {{ tag }}
                  <button @click.prevent="removeTag(index)" class="ml-2">
                    <img src="@/assets/dashboard/iconoir_cancel.svg" alt="Close" class="w-4 h-4" />
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-end mb-4 text-[14px]">
          <button type="button" class="mr-4 py-2 px-4 bg-primaryLight border border-grayLight text-grayDark rounded cursor-pointer" @click="closeModal">Cancel</button>
          <button type="submit" class="flex items-center gap-2 py-2 px-4 bg-primaryDarkBg w-[] h-[42px] text-white rounded">
            <img src="@/assets/dashboard/add.svg" alt="User icon" class="h-4">
            Create Project
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import apiClient from '@/axios'

export default {
  name: 'CreateProjectModal',
  components: {
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      loading: false, // Track loading state
      managers: [],
      selectedManagerId: null,
      modalTitle: 'Create Project',
      newProject: {
        project_name: '',
        description: '',
        start_date: '',
        end_date: '',
        status: 'Active',
        tags: []
      },
      managerName: '',
      managerEmail: '',
      coverImage: null, // Store the file object
      coverImagePreview: null, // Store the image preview URL
      availableTags: ['Urgent', 'Backend', 'Frontend', 'Design', 'QA', 
      'Software Engineering', 
        'UI/UX Design', 'Robotics', 'Iot',
        'Embedded Systems',
        'Extended Reality'
      ], // Predefined list of tags
      selectedTag: '', // Temporarily store the selected tag
    }
  },
  watch: {
    showModal(newVal) {
      if (newVal) {
        this.fetchManagerData();
      }
    }
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isManager() {
      return this.$store.getters.isManager;
    }
  },

  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.coverImage = file;
        // Create a preview URL for the image
        this.coverImagePreview = URL.createObjectURL(file);
      }
    },
    
    async fetchManagerData() {
      this.loading = true; // Start loading

      try {
        if (this.isManager) {
          // Fetch details of the logged-in manager
          const response = await apiClient.get(`/web/manager/me`);
          const managerData = response.data.data;
          this.managerName = managerData.contact_name
          this.managerEmail = managerData.contact_email;
          this.selectedManagerId = managerData.manager_id; // Set the manager ID for form submission
        } else if (this.isAdmin) {
          // Fetch list of all managers
          const response = await apiClient.get(`/web/managers`);
          this.managers = response.data.data;
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        this.$toast.error('Failed to fetch data. Please try again.');
      } finally {
        this.loading = false; // Stop loading
      }
    },

    closeModal() {
      // Clean up any created object URLs when closing modal
      if (this.coverImagePreview) {
        URL.revokeObjectURL(this.coverImagePreview);
        this.coverImagePreview = null;
      }
      this.$emit('close') // Emit close event to parent
      this.resetForm();
      this.clearErrorMessage(); // Clear error message on modal close
    },
    
    resetForm() {
      this.newProject = {
        project_name: '',
        description: '',
        start_date: new Date().toISOString().split('T')[0],
        end_date: '',
        status: 'Active',
        tags: []
      };
      this.coverImage = null;
      this.coverImagePreview = null;
    },
    
    // Clear the message
    clearErrorMessage() {
      // no-op
    },
    
    addTag() {
      if (this.selectedTag && !this.newProject.tags.includes(this.selectedTag)) {
        this.newProject.tags.push(this.selectedTag);
        this.selectedTag = ''; // Reset the dropdown
      }
    },
    
    removeTag(index) {
      this.newProject.tags.splice(index, 1); // Remove tag by index
    },
    
    // Format date in ISO format with T separator for backend API
    formatDateForAPI(dateString) {
      if (!dateString) return '';
      // Ensure we have a proper date format with 'T' separator and time component
      const date = new Date(dateString);
      return date.toISOString(); // Returns format like "2025-05-12T00:00:00.000Z"
    },
    
    async submitModal() {
      try {
        // Create a FormData object to handle file uploads
        const formData = new FormData();
        
        // Add project details to the form data
        formData.append('manager_id', this.selectedManagerId);
        formData.append('project_name', this.newProject.project_name);
        formData.append('description', this.newProject.description);
        
        // Format dates properly before sending to API
        formData.append('start_date', this.formatDateForAPI(this.newProject.start_date));
        formData.append('end_date', this.formatDateForAPI(this.newProject.end_date));
        
        formData.append('status', this.newProject.status);
        
        // Add tags as JSON string or as multiple values based on your API
        if (this.newProject.tags.length > 0) {
          formData.append('tags', JSON.stringify(this.newProject.tags));
        }
        
        // Add the cover image if one was selected
        if (this.coverImage) {
          formData.append('cover_image', this.coverImage);
        }
        
        // Set the correct headers for multipart/form-data
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        
        // Submit the form data
        const response = await apiClient.post('/web/projects', formData, config);
        const createdProject = response.data.data;

        this.$emit('projectCreated', 'Project created successfully!');
        this.$emit('refresh');
        this.closeModal();

        if (createdProject && createdProject.project_id) {
          this.$router.push(`/projects/${createdProject.project_id}`);
        }

      } catch (error) {
        // Check for detailed validation errors
        if (error.response?.data?.detail) {
          // Format and display validation errors
          const errorDetails = error.response.data.detail;
          if (Array.isArray(errorDetails)) {
            this.$toast.error(errorDetails.map(err => err.msg || err.message).join(', '));
          } else {
            this.$toast.error('Validation error: Please check your inputs');
          }
        } else {
          this.$toast.error(error.response?.data?.message || 'An unexpected error occurred.');
        }
        console.error('Error creating project:', error);
      }
    },
    
    handleProjectCreated() {
      // no-op: toast handled inline
    },
  },

  created() {
    this.fetchManagerData();
    const today = new Date();
    this.newProject.start_date = today.toISOString().split('T')[0]; // Format as YYYY-MM-DD
  
    // Preselect the manager if the user is a manager
    if (this.isManager) {
      this.selectedManagerId = this.managerId;  // Assuming `managerId` is stored when logged in
    }
  },
  
  beforeUnmount() {
    // Clean up any created object URLs when component is unmounted
    if (this.coverImagePreview) {
      URL.revokeObjectURL(this.coverImagePreview);
    }
  }
}
</script>

<style scoped>
.modal-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  inset: 0;
  z-index: 50;
}

.smoke-light {
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  position: relative;
  z-index: 60;
}
</style>